export default __webpack_public_path__ + "static/google_Desktop3-1d86fca4f71403361542f4d2d00e4293.svg";